<template>
    <div>
        <van-sticky>
            <van-nav-bar
                    title="派车计划"
                    left-text=""
                    left-arrow
                    @click-left="back()"
                    v-if="show"
            />
            <van-search
                    v-model="selVal.key"
                    show-action
                    placeholder="派车单号/车号/收货地址"
                    @search="onSearch"
                    clearable
                    left-icon=""
            >
                <template #action>
                    <div @click="onSearch">
                        <van-icon name="search" size="1.5rem" style="vertical-align: middle"/>
                    </div>
                </template>
            </van-search>
        </van-sticky>

        <van-tabs color="#6685a4" title-active-color="#6685a4" line-width="100px">
            <van-tab title="进行中">
                <!--        首页-->
                <van-pull-refresh v-model="inIsLoading" @refresh="onRefresh"
                                  style="height: calc(100vh - 234px); overflow: auto;">
                    <van-list
                            v-model="inLoading"
                            :finished="inFinished"
                            finished-text="没有更多了"
                            @load="onLoad"
                    >
                        <van-cell v-for="item in inList" :key="item.orderplanId"
                                  @click="showPopDetail(item.orderplanId)">
                            <van-row gutter="20">
                                <van-col span="12" class="ellipsis">
                                    单号：{{item.orderplanNo}}
                                </van-col>
                                <van-col span="12" class="ellipsisRight">
                                    状态：{{ item.status | formatOrderPlanStatus}}
                                </van-col>
                            </van-row>
                            <van-row gutter="20">
                                <van-col span="10" class="ellipsis">
                                    发货仓：{{item.warehouseStoreName}}
                                </van-col>
                                <van-col span="14" class="ellipsisRight">
                                    收货地：{{item | formatCityAndDis}}
                                </van-col>
                            </van-row>

                            <van-row gutter="20">
                                <van-col span="12" class="ellipsis">
                                    车号：{{item.vehicleNo}}
                                </van-col>
                                <van-col span="12" class="ellipsisRight">
                                    货品：{{item.cargo}} {{item.weight}}吨
                                </van-col>
                            </van-row>
                        </van-cell>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
            <van-tab title="已完成">
                <!--        首页-->
                <van-pull-refresh v-model="completeIsLoading" @refresh="onRefresh"
                                  style="height: calc(100vh - 234px); overflow: auto;">
                    <van-list
                            v-model="completeLoading"
                            :finished="completeFinished"
                            finished-text="没有更多了"
                            @load="onLoad"
                    >
                        <van-cell v-for="item in completeList" :key="item.orderplanId"
                                  @click="showPopDetail(item.orderplanId)">
                            <van-row gutter="20">
                                <van-col span="12" class="ellipsis">
                                    单号：{{item.orderplanNo}}
                                </van-col>
                                <van-col span="12" class="ellipsisRight">
                                    状态：{{ item.status | formatOrderPlanStatus}}
                                </van-col>
                            </van-row>
                            <van-row gutter="20">
                                <van-col span="10" class="ellipsis">
                                    发货仓：{{item.warehouseStoreName}}
                                </van-col>
                                <van-col span="14" class="ellipsisRight">
                                    收货地：{{item | formatCityAndDis}}
                                </van-col>
                            </van-row>

                            <van-row gutter="20">
                                <van-col span="12" class="ellipsis">
                                    车号：{{item.vehicleNo}}
                                </van-col>
                                <van-col span="12" class="ellipsisRight">
                                    货品：{{item.cargo}} {{item.weight}}吨
                                </van-col>
                            </van-row>
                        </van-cell>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
        </van-tabs>
        <div class="van-address-list__bottom">
            <van-button block size="small" type="info" native-type="submit" class="button"
                        @click="addPop()">
                新建
            </van-button>
        </div>

        <!--        派车创建-->
        <van-popup v-model="addShowPop" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
            <van-nav-bar
                    :title="showPlanEdit == true ? '派车计划修改' : '派车计划创建'"
                    fixed
                    left-arrow
                    z-index="9000"
                    @click-left="() => this.addShowPop = false"
            />
            <div>
                <div class="searchwarp address" style="height: calc(100vh - 90px); overflow: auto;">
                    <van-field label="用车时间" placeholder="点击选择时间" :value="newVal.vehicleTime" readonly required
                               @click="showPicker('calendarShow')" label-width="80px" label-align="right"/>
                    <van-field class="noon">
                        <template #button>
                            <van-radio-group v-model="radio" direction="horizontal" ref="radio">
                                <van-radio name="1" shape="square" @click="choose('mor')">上午</van-radio>
                                <van-radio name="2" shape="square" @click="choose('aft')">下午</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field readonly name="picker" label="发货仓" placeholder="点击选择发货仓" v-model="warehouseStoreName"
                               required
                               @click="showPicker('showPickerSto')"
                               label-width="80px" label-align="right"/>
                    <div class="van-doc-demo-block">
                        <h2 class="van-doc-demo-block__title">地址信息</h2>
                    </div>
                    <van-field label="收货单位" placeholder="请选择收货单位" autocomplete="off" readonly required
                               v-model="newVal.receiveName"
                               @click="showRecSel()"
                               label-width="80px" label-align="right">
                        <template #button>
                            <van-icon name="arrow"/>
                        </template>
                    </van-field>
                    <van-field
                            v-model="newVal.area"
                            type="textarea"
                            autosize
                            @click="showRecSel()"
                            label="详细地址"
                            placeholder="请选择详细地址"
                            input-align="left"
                            readonly
                            label-width="80px"
                            label-align="right"
                            required
                            rows="1"
                    />
                    <van-field label="联系人" placeholder="请选择联系人" autocomplete="off" readonly
                               v-model="newVal.receiveContacts"
                               @click="showRecSel()"
                               label-width="80px" label-align="right"
                               required/>
                    <van-field label="手机号码" placeholder="请输入手机号码" autocomplete="off" readonly required
                               v-model="newVal.receiveContactsTel" @click="showRecSel()"
                               label-width="80px" label-align="right"/>

                    <div class="van-doc-demo-block">
                        <h2 class="van-doc-demo-block__title">货品信息</h2>
                    </div>

                    <van-field label="品名" placeholder="点击输入品名" v-model="newVal.cargo" required
                               label-width="80px" label-align="right"/>
                    <van-field label="重量" placeholder="请输入重量" v-model="newVal.weight" required
                               label-width="80px" label-align="right"/>
                    <div class="van-doc-demo-block">
                        <h2 class="van-doc-demo-block__title">要求说明</h2>
                    </div>
                    <van-field
                            v-model="newVal.remarks"
                            type="textarea"
                            autosize
                            placeholder="请输入要求"
                            input-align="left"
                            label-width="80px"
                            label-align="right"
                    />
                </div>
                <van-row class="van-address-detail__bottom">
                    <van-col span="12" v-if="showPlanEdit">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="delOrderPlan()">
                            删除
                        </van-button>
                    </van-col>
                    <!-- <van-col span="12" v-if="!showPlanEdit">
                         <van-button block size="small" type="info" native-type="submit" class="button"
                                     @click="reset()">
                             重置
                         </van-button>
                     </van-col>-->
                    <van-col :span="showPlanEdit ? 12 : 24">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="onConfirmPlan()">
                            保存
                        </van-button>
                    </van-col>
                </van-row>
                <van-calendar v-model="calendarShow"
                              :min-date=" new Date()"
                              :default-date="new Date()"
                              type="single" @confirm="calendarConfirm"/>
            </div>
        </van-popup>
        <van-popup v-model="showPickerSto" position="bottom" :style="{ height: '310px' }">
            <van-picker
                    title="发货仓"
                    show-toolbar
                    :columns="warehouseStoreNameCol"
                    @confirm="selWarehouseStoreVal"
                    @cancel="showPickerSto = false"
            />
        </van-popup>

        <!--        收货地址主页-->
        <van-popup v-model="showRec" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
            <van-nav-bar
                    title="收货地址选择"
                    left-arrow
                    @click-left="()=>this.showRec=false"
                    right-text="新建"
                    @click-right="addPopRec()"
            />
            <van-search
                    v-model="key"
                    show-action
                    placeholder="收货单位/联系人/电话/地址"
                    @search="onSearchRec"
                    clearable
                    left-icon=""
            >
                <template #action>
                    <div @click="onSearchRec">
                        <van-icon name="search" size="1.5rem" style="vertical-align: middle"/>
                    </div>
                </template>
            </van-search>
            <template>
                <div style="height: calc(100vh - 106px); overflow: auto;">
                    <van-pull-refresh v-model="isLoadingRec" @refresh="onRefreshRec">
                        <van-list
                                style="margin-bottom: 40px"
                                v-model="loadingRec"
                                :finished="finishedRec"
                                finished-text="没有更多了"
                                @load="selCustomerReceiveP"
                        >
                            <van-radio-group v-model="radioRec">
                                <van-cell v-for="item in listRec"
                                          :key="item.customerReceiveId">
                                    <div class="van-cell van-cell--borderless"
                                         style="padding: 0px;">
                                        <div class="van-radio" style="flex: 11">
                                            <div class="van-radio__icon van-radio__icon--round" style="font-size: 18px">
                                                <van-radio :name="item.radio"/>
                                            </div>
                                            <span class="van-radio__label" style="flex: 1;margin-left: 12px;">
                                            <div clickable @click="radioRec = chooseRec(item)" style="flex: 1">
                                                <div class="van-address-item__name"
                                                     style="margin: 0px 0px 4px">{{item.receiveName}}</div>
                                                <div class="van-address-item__address">{{item | formatArea}}</div>
                                                <div class="van-address-item__address"
                                                     span="24">{{item.receiveAddress}}</div>
                                                <div class="van-address-item__address">{{item.contacts}} {{item.contactsTel}}</div>
                                                <div class="van-address-item__address">{{item.remarks}}</div>
                                            </div>
                                        </span>
                                        </div>
                                        <div style="flex: 1" clickable @click="onEdit(item)"></div>
                                        <div class="van-icon van-icon-edit van-radio"
                                             style="color:#6685a4;font-size:20px;width: 25px;flex: 1;justify-content: right;"
                                             @click="onEdit(item)">
                                        </div>
                                    </div>
                                </van-cell>
                            </van-radio-group>
                        </van-list>

                    </van-pull-refresh>
                </div>
            </template>
            <div class="van-address-detail__bottom">
                <van-button block type="info" native-type="submit" class="button" @click="onConfirm()">
                    确定
                </van-button>
            </div>
        </van-popup>

        <!--        收货地址新建修改-->
        <van-popup v-model="addShowPopRec" :style="{ height: '100%', width:'100%'}">
            <van-nav-bar
                    :title="this.showEdit == false ? '收货地址新建' : '收货地址修改'"
                    fixed
                    left-arrow
                    z-index="9000"
                    @click-left="()=>this.addShowPopRec=false"
            />
            <div class="searchwarp address">
                <van-field v-model="addValue.receiveName" label="收货单位" placeholder="公司名称" required v-if="!showEdit"
                           input-align="right">
                </van-field>
                <van-field v-model="selValue.receiveName" label="收货单位" placeholder="公司名称" required v-if="showEdit"
                           input-align="right">
                </van-field>
                <van-field v-model="addValue.area" readonly label="所在地区" placeholder="选择省 / 市 / 区" v-if="!showEdit"
                           @click="() => showAreaAdd()" required input-align="right">
                </van-field>
                <van-field v-model="selValue.area" readonly label="所在地区" placeholder="选择省 / 市 / 区" v-if="showEdit"
                           @click="() => showAreaEdit()" required input-align="right">
                </van-field>
                <van-field v-model="addValue.receiveAddress" label="详细地址" placeholder="街道门牌、楼层房间号等信息" required
                           v-if="!showEdit"
                           input-align="right">
                </van-field>
                <van-field v-model="selValue.receiveAddress" label="详细地址" placeholder="街道门牌、楼层房间号等信息" required
                           v-if="showEdit"
                           input-align="right">
                </van-field>
                <van-field v-model="addValue.contacts" label="联系人" placeholder="联系人姓名" required v-if="!showEdit"
                           input-align="right">
                </van-field>
                <van-field v-model="selValue.contacts" label="联系人" placeholder="联系人姓名" required v-if="showEdit"
                           input-align="right">
                </van-field>
                <van-field v-model="addValue.contactsTel" type="tel" label="手机号码" placeholder="联系人手机号" required
                           v-if="!showEdit"
                           input-align="right">
                </van-field>
                <van-field v-model="selValue.contactsTel" type="tel" label="手机号码" placeholder="联系人手机号" required
                           v-if="showEdit"
                           input-align="right">
                </van-field>
                <van-field
                        v-model="addValue.remarks"
                        rows="2"
                        label="备注"
                        type="textarea"
                        placeholder="请输入留言"
                        input-align="right"
                        v-if="!showEdit"
                />
                <van-field
                        v-model="selValue.remarks"
                        rows="2"
                        label="备注"
                        type="textarea"
                        placeholder="请输入留言"
                        input-align="right"
                        v-if="showEdit"
                />
                <van-row class="van-address-detail__bottom">
                    <van-col span="12" v-if="!this.showEdit">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="resetRec()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="12" v-if="this.showEdit">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="del()">
                            删除
                        </van-button>
                    </van-col>
                    <van-col span="12">
                        <van-button block size="small" type="info" native-type="submit" class="button"
                                    @click="save()">
                            保存
                        </van-button>
                    </van-col>
                </van-row>

                <van-popup v-model="showSelAreaStatusValAdd" position="bottom" :style="{ height: '310px' }">
                    <van-area title="地区选择"
                              :area-list="areaList"
                              v-model="addValue.receiveRegionId"
                              value="receiveRegion"
                              :columns-num="3"
                              v-if="showPickerArea && !showEdit"
                              @cancel="areaStatusValAddCancel"
                              @confirm="selAreaStatusValAdd"
                    />
                </van-popup>
                <van-popup v-model="showSelAreaStatusValEdit" position="bottom" :style="{ height: '310px' }">
                    <van-area title="地区选择"
                              :area-list="areaList"
                              v-model="selValue.receiveRegionId"
                              value="receiveRegion"
                              :columns-num="3"
                              v-if="showPickerArea && showEdit"
                              @cancel="areaStatusValEditCancel"
                              @confirm="selAreaStatusValEdit"
                    />
                </van-popup>
            </div>
        </van-popup>

        <!--        派车计划详情-->
        <van-popup v-model="showDetail" position="center" :style="{ height: '100%', width:'100%',overflow: 'hidden'}">
            <van-nav-bar
                    title='派车计划详情'
                    left-arrow
                    z-index="9000"
                    :right-text="curDetail.status == 10 ? '修改' : ''"
                    @click-right="showEditDetail()"
                    @click-left="()=>this.showDetail=false"
            />
            <template>
                <div class="dback-all" style="height: calc(100vh - 86px); overflow: auto;">

                    <div class="van-doc-demo-block">
                        <div class="van-cell-group van-hairline--bottom">
                            <div class="van-cell" style="align-items: center;">
                                <div class="van-doc-demo-block__title" style="padding: 0px;"><span>{{curDetail.orderplanNo}}</span>
                                </div>
                                <div class="van-cell__value"><span>{{curDetail.status | formatOrderPlanStatus}}</span>
                                </div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>发货仓</span></div>
                                <div class="van-cell__value"><span>{{curDetail.warehouseStoreName}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>计划用车时间</span></div>
                                <div class="van-cell__value"><span>{{curDetail.vehicleTimeFormat}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>货品</span></div>
                                <div class="van-cell__value"><span>{{curDetail.cargo}} {{curDetail.weight}}吨</span>
                                </div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>要求说明</span></div>
                                <div class="van-cell__value"><span>{{curDetail.remarks}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="van-doc-demo-block">
                        <van-row>
                            <van-col span="12"><h2 class="van-doc-demo-block__title">收货地址</h2></van-col>
                        </van-row>

                        <div class="van-cell-group van-hairline--top-bottom">
                            <div class="van-cell">
                                <div class="van-cell__title"><span>收货单位</span></div>
                                <div class="van-cell__value"><span>{{curDetail.receiveName}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>详情地址</span></div>
                                <div class="van-cell__value"><span>{{curDetail.areaFormat}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>联系人</span></div>
                                <div class="van-cell__value"><span>{{curDetail.receiveContacts}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>手机号码</span></div>
                                <div class="van-cell__value"><span>{{curDetail.receiveContactsTel}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="van-doc-demo-block" v-if="showMore()">
                        <van-row>
                            <van-col span="12"><h2 class="van-doc-demo-block__title">派车信息</h2></van-col>
                            <van-col span="12"><h2 class="van-doc-demo-block__title"
                                                   style="text-align: right;font-weight: bold;color: #333">
                                运费：{{curDetail.quotedPrice}}元</h2>
                            </van-col>
                        </van-row>
                        <div class="van-cell-group van-hairline--top-bottom">
                            <div class="van-cell">
                                <div class="van-cell__title"><span>车号</span></div>
                                <div class="van-cell__value"><span>{{curDetail.vehicleNo}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>车型</span></div>
                                <div class="van-cell__value"><span>{{curDetail.vehicleType}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>驾驶员</span></div>
                                <div class="van-cell__value"><span>{{curDetail.driverName}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>身份证号码</span></div>
                                <div class="van-cell__value"><span>{{curDetail.driverIdnumber}}</span></div>
                            </div>
                            <div class="van-cell">
                                <div class="van-cell__title"><span>备注</span></div>
                                <div class="van-cell__value"><span>{{curDetail.remarks}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="van-doc-demo-block">
                        <h2 class="van-doc-demo-block__title">跟踪信息</h2>
                        <van-cell v-for="item in curDetail.planDetail" :key="item.orderplanLogId">
                            <van-row gutter="20">
                                <van-col span="18" class="ellipsis">
                                    <div>{{ item.createTime | moment("YY-MM-DD HH:mm:ss")}}</div>
                                </van-col>
                                <van-col span="6" class="ellipsisRight">
                                    {{item | formatShowStatus}}
                                </van-col>
                            </van-row>
                            <van-row gutter="20">
                                <van-col span="24" style="overflow: hidden;text-align: left;">
                                    {{ item.logInfo }}
                                </van-col>
                            </van-row>
                        </van-cell>
                    </div>
                </div>
            </template>
            <div class="van-address-detail__bottom" v-if="curDetail.status == 10 ? true : false">
                <van-col span="24">
                    <van-button block size="small" type="info" native-type="submit" class="button"
                                @click="submitOrderPlan()">
                        提交
                    </van-button>
                </van-col>
            </div>
            <div class="van-address-detail__bottom" v-if="curDetail.status == 20 ? true : false">
                <van-col span="24">
                    <van-button block size="small" type="info" native-type="submit" class="button"
                                @click="cancelOrderPlan()">
                        取消
                    </van-button>
                </van-col>
            </div>
            <div class="van-address-detail__bottom" v-if="curDetail.status == 40 ? true : false">
                <van-col span="24">
                    <van-button block size="small" type="info" native-type="submit" class="button"
                                @click="confirmOrderPlan()">
                        确认报价
                    </van-button>
                </van-col>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {Area, Dialog, Tab, Tabs} from 'vant';
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'
    import {areaList} from "@vant/area-data";
    import {
        checkDouble,
        checkNumLength,
        isAllEmpty,
        isEmpty,
        isPhone,
        messageContent,
        resCode,
        cancelStr,
    } from "../../utils/tools";

    Vue.use(Area);
    Vue.use(Tab);
    Vue.use(Tabs);
    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                show: true,//nav bar
                inList: [],
                completeList: [],
                inLoading: true,
                completeLoading: true,
                inFinished: false,
                completeFinished: false,
                //刷新
                inIsLoading: false,
                completeIsLoading: false,
                inPage: 1,
                completePage: 1,
                pageSize: 20,
                selVal: {
                    key: undefined,
                },
                addShowPop: false,
                radio: '2',
                newVal: {
                    orderplanId: undefined,
                    vehicleTime: undefined,
                    vehicleTimeAp: undefined,
                    warehouseStoreId: undefined,
                    receiveName: undefined,
                    receiveRegionId: undefined,
                    receiveAddress: undefined,
                    receiveContacts: undefined,
                    receiveContactsTel: undefined,
                    area: undefined,
                    cargo: undefined,
                    weight: undefined,
                    remarks: undefined,
                },
                calendarShow: false,
                waregouseStoreData: [],
                warehouseStoreNameCol: [],
                showPickerSto: false,
                warehouseStoreName: '',

                //收货地址
                radioRec: 1,
                key: '',
                showRec: false,//nav bar
                listRec: [],
                loadingRec: true,
                finishedRec: false,
                addValue: {
                    receiveName: undefined,
                    receiveAddress: undefined,
                    contacts: undefined,
                    contactsTel: undefined,
                    area: undefined,
                },
                selValue: {
                    receiveName: undefined,
                    receiveRegionId: undefined,
                    receiveAddress: undefined,
                    contacts: undefined,
                    contactsTel: undefined,
                    area: undefined,
                },
                addShowPopRec: false,
                dateFormat: 'YYYY-MM-DD',
                //刷新
                isLoadingRec: false,
                pageRec: 1,
                pageSizeRec: 20,
                areaList,
                showPickerArea: false,
                showEdit: false,
                showPlanEdit: false,
                showDetail: false,
                curDetail: {
                    orderplanId: undefined,
                    orderplanNo: undefined,
                    status: undefined,
                    warehouseStoreName: undefined,
                    warehouseStoreId: undefined,
                    vehicleTimeFormat: undefined,
                    vehicleTime: undefined,
                    vehicleTimeAp: undefined,
                    cargo: undefined,
                    weight: undefined,
                    remarks: undefined,
                    receiveName: undefined,
                    areaFormat: undefined,
                    area: undefined,
                    receiveAddress: undefined,
                    receiveRegionId: undefined,
                    receiveContacts: undefined,
                    receiveContactsTel: undefined,
                    quotedPrice: undefined,
                    vehicleNo: undefined,
                    vehicleType: undefined,
                    driverName: undefined,
                    driverIdnumber: undefined,
                    planDetail: [],
                },
                showSelAreaStatusValAdd: false,
                showSelAreaStatusValEdit: false,
            }
        },
        filters: {
            formatShowStatus(item) {
                let text = item.status
                if (text == 10) {
                    return cancelStr('创建', item.iscancel)
                } else if (text == 20) {
                    return cancelStr('提交', item.iscancel)
                } else if (text == 30) {
                    return cancelStr('受理', item.iscancel)
                } else if (text == 40) {
                    return cancelStr('报价', item.iscancel)
                } else if (text == 50) {
                    return cancelStr('确认', item.iscancel)
                } else if (text == 60) {
                    return cancelStr('派车', item.iscancel)
                } else if (text == 70) {
                    return cancelStr('到车', item.iscancel)
                } else if (text == 80) {
                    return cancelStr('发车', item.iscancel)
                } else if (text == 100) {
                    return cancelStr('签收', item.iscancel)
                } else {
                    return ''
                }
            },
            formatArea(item) {
                if (item.area == null) {
                    return item.city + '/' + item.district
                } else {
                    return item.area
                }
            },
            formatCityAndDis(item) {
                let city = item.city
                let district = item.district
                if (city != null && district != null) {
                    return city + '/' + district
                }
            },
            formatOrderPlanStatus(text) {
                if (text == 10) {
                    return '新建'
                } else if (text == 20) {
                    return '已提交'
                } else if (text == 30) {
                    return '已受理'
                } else if (text == 40) {
                    return '已报价'
                } else if (text == 50) {
                    return '已确认'
                } else if (text == 60) {
                    return '已派车'
                } else if (text == 70) {
                    return '已到车'
                } else if (text == 80) {
                    return '已发车'
                } else if (text == 100) {
                    return '已签收'
                } else {
                    return ''
                }
            },
        },
        mounted() {
            let param = {};
            param.ouid = localStorage.getItem("ouid")
            service.selWaregouseStoreG(param).then(res => {
                let data = res.data;
                this.waregouseStoreData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.warehouseStoreNameCol.push(data[i].warehouseStoreName)
                }
            })
            this.onLoad();
        },
        methods: {
            /*displayButton() {
                // 获取视图原始高度
                let screenHeight = document.body.offsetHeight
                console.log(screenHeight)
                // 为window绑定resize事件
                window.onresize = function () {
                    let nowHeight = document.body.offsetHeight
                    console.log(nowHeight)
                    console.log(screenHeight)
                    if (nowHeight < screenHeight) {
                        // 将底部弹起的按钮隐藏（可使用给按钮添加相应消失类）
                        this.isShowButton = false
                    } else {
                        // 将按钮正常显示（可使用给按钮移除相应消失类）
                        this.isShowButton = true

                    }
                }
            },*/
            showEditDetail() {
                this.showPlanEdit = true
                this.addShowPop = true
                this.newVal.orderplanId = this.curDetail.orderplanId
                this.newVal.vehicleTime = this.$moment(this.curDetail.vehicleTime).format("YYYY-MM-DD")
                this.newVal.vehicleTimeAp = this.curDetail.vehicleTimeAp
                this.radio = this.formatAp(this.curDetail.vehicleTimeAp)
                this.warehouseStoreName = this.curDetail.warehouseStoreName
                this.newVal.warehouseStoreId = this.curDetail.warehouseStoreId
                this.newVal.receiveName = this.curDetail.receiveName
                this.newVal.receiveRegionId = this.curDetail.receiveRegionId
                this.newVal.receiveAddress = this.curDetail.receiveAddress
                this.newVal.area = this.curDetail.areaFormat
                this.newVal.receiveContacts = this.curDetail.receiveContacts
                this.newVal.receiveContactsTel = this.curDetail.receiveContactsTel
                this.newVal.cargo = this.curDetail.cargo
                this.newVal.weight = this.curDetail.weight
                this.newVal.remarks = this.curDetail.remarks
            },
            showMore() {
                if (this.curDetail.status == 10 || this.curDetail.status == 20) {
                    return false
                } else {
                    return true
                }
            },
            formatAp(val) {
                if (val == 10) {
                    return '1'
                } else if (val == 20) {
                    return '2'
                } else {
                    return '1'
                }
            },
            formatTimeStr(text) {
                if (text == 10) {
                    return '上午'
                } else if (text == 20) {
                    return '下午'
                } else {
                    return ''
                }
            },
            formatArea(area, address) {
                if (!isEmpty(area) && !isEmpty(address)) {
                    return area + ' ' + address
                } else {
                    return ''
                }
            },
            onConfirmPlan() {
                let param = this.newVal
                if (isAllEmpty(param.vehicleTime)) {
                    Toast('请选择用车时间')
                } else if (isAllEmpty(param.warehouseStoreId)) {
                    Toast('请选择发货仓')
                } else if (isAllEmpty(param.receiveName)) {
                    Toast('请选择收货单位')
                } else if (isAllEmpty(param.cargo)) {
                    Toast('请输入品名')
                } else if (isAllEmpty(param.weight)) {
                    Toast('请输入重量')
                } else if (!checkDouble(param.weight)) {
                    Toast('重量格式错误，请重新输入')
                } else if (!checkNumLength(param.weight, 6, 2)) {
                    Toast('重量过大，请重新输入')
                } else {
                    if (isAllEmpty(param.vehicleTimeAp)) {
                        param.vehicleTimeAp = 10
                    }
                    param.ouid = localStorage.getItem("ouid")
                    param.customerId = localStorage.getItem("customerId")
                    param.status = 10
                    if (!this.showPlanEdit) {
                        console.log(param)
                        service.addtmsOrderPlan(param).then(res => {
                            if (res.code == resCode.success) {
                                Toast(messageContent.addSuccess)
                                this.addShowPop = false;
                                this.reset()
                                this.showPopDetail(res.data)
                            } else {
                                Toast(res.msg)
                            }
                        })
                    } else {
                        console.log(param)
                        service.updtmsOrderPlan(param).then(res => {
                            if (res.code == resCode.success) {
                                Toast(messageContent.editSuccess)
                                // this.reset()
                                this.showPopDetail(param.orderplanId)
                                this.addShowPop = false
                            } else {
                                Toast(res.msg)
                            }
                        })
                    }
                }
            },
            selCustomerReceiveP() {
                let param = {}
                param.key = this.key
                param.ouid = localStorage.getItem("ouid")
                param.customerId = localStorage.getItem("customerId")
                param.limit = this.pageSizeRec
                param.page = this.pageRec
                service.selCustomerReceiveP(param).then(res => {
                    if (res.code == resCode.success) {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                res.data[i].radio = i + 1;
                                this.listRec.push(res.data[i]);
                            }
                            this.pageRec++
                            this.selValue = res.data[0]
                        } else {
                            this.finishedRec = true;
                        }
                        // 加载状态结束
                        this.loadingRec = false;
                        this.isLoadingRec = false;
                    } else {
                        this.loadingRec = false;
                        this.finishedRec = true;
                        this.isLoadingRec = false;
                        Toast(res.msg)
                    }
                })
            },
            delOrderPlan() {
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定删除吗？',
                    confirmButtonColor: "#6685a4"
                }).then(() => {
                    service.deltmsOrderPlan({orderplanId: this.curDetail.orderplanId}).then(res => {
                        if (res.code == resCode.success) {
                            Toast(messageContent.deleteSuccess)
                            this.showDetail = false;
                            this.reset()
                            this.onSearch()
                        } else {
                            Toast(res.msg)
                        }
                    })
                }).catch(() => {

                })
            },
            submitOrderPlan() {
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定提交吗？',
                    confirmButtonColor: "#6685a4"
                }).then(() => {
                    service.submittmsOrderPlan({orderplanId: this.curDetail.orderplanId}).then(res => {
                        if (res.code == resCode.success) {
                            Toast(messageContent.submitSuccess)
                            this.showDetail = false;
                            this.reset()
                            this.onSearch()
                        } else {
                            Toast(res.msg)
                        }
                    })
                }).catch(() => {

                })
            },
            cancelOrderPlan() {
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定取消吗？',
                    confirmButtonColor: "#6685a4"
                }).then(() => {
                    service.submittmsOrderPlanByCancel({orderplanId: this.curDetail.orderplanId}).then(res => {
                        if (res.code == resCode.success) {
                            Toast(messageContent.submitSuccess)
                            this.showDetail = false;
                            this.reset()
                            this.onSearch()
                        } else {
                            Toast(res.msg)
                        }
                    })
                }).catch(() => {

                })
            },
            confirmOrderPlan() {
                Dialog.confirm({
                    title: '提示消息',
                    message: '是否确认报价',
                    confirmButtonColor: "#6685a4"
                }).then(() => {
                    service.confirmtmsOrderPlan({orderplanId: this.curDetail.orderplanId}).then(res => {
                        if (res.code == resCode.success) {
                            Toast(messageContent.confirmSuccess)
                            this.showDetail = false;
                            this.reset()
                            this.onSearch()
                        } else {
                            Toast(res.msg)
                        }
                    })
                }).catch(() => {

                })
            },
            showRecSel() {
                this.showRec = true
                this.selCustomerReceiveP();
            },
            selWarehouseStoreVal(value, index) {
                console.log(value)
                this.warehouseStoreName = value;
                this.newVal.warehouseStoreId = this.waregouseStoreData[index].warehouseStoreId
                this.showPickerSto = false;
            },
            choose(flag) {
                if (flag == 'mor') {
                    this.newVal.vehicleTimeAp = 10
                } else if (flag == 'aft') {
                    this.newVal.vehicleTimeAp = 20
                }
            },
            calendarConfirm(date) {
                this.calendarShow = false;
                this.newVal.vehicleTime = this.$moment(date).format("YYYY-MM-DD")
            },
            showPicker(pickerName) {
                this.calendarShow = false
                this.showPickerSto = false
                this.showPickerIns = false
                this.showPickerCar = false
                this.showPickerMode = false
                this.showPickerMat = false
                this.showPickerOri = false
                this.showPickerSur = false
                this.showPickerArea = false

                switch (pickerName) {
                    case 'calendarShow':
                        this.calendarShow = true
                        break
                    case 'showPickerSto':
                        this.showPickerSto = true
                        break
                    case 'showPickerArea':
                        this.showPickerArea = true
                        break
                    case 'showPickerIns':
                        this.showPickerIns = true
                        break
                    case 'showPickerCar':
                        this.showPickerCar = true
                        break
                    case 'showPickerMode':
                        this.showPickerMode = true
                        break
                    case 'showPickerMat':
                        this.showPickerMat = true
                        break
                    case 'showPickerOri':
                        this.showPickerOri = true
                        break
                    case 'showPickerSur':
                        this.showPickerSur = true
                        break
                    default:
                        return false
                }
            },
            showAreaAdd() {
                this.showPickerArea = true
                this.showSelAreaStatusValAdd = true
            },
            showAreaEdit() {
                this.showPickerArea = true
                this.showSelAreaStatusValEdit = true
            },
            onRefresh() {
                this.onLoad();
            },
            onRefreshRec() {
                this.selCustomerReceiveP();
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            addPop() {
                this.show = true;
                this.addShowPop = true;
                this.showPlanEdit = false;
                this.reset();
            },
            showPopDetail(id) {
                service.seltmsOrderPlanByID({orderplanId: id}).then(res => {
                    if (res.code == resCode.success) {
                        let item = res.data.plan
                        this.curDetail = {
                            orderplanId: item.orderplanId,
                            orderplanNo: item.orderplanNo,
                            status: item.status,
                            warehouseStoreName: item.warehouseStoreName,
                            warehouseStoreId: item.warehouseStoreId,
                            vehicleTimeFormat: this.$moment(item.vehicleTime).format("YYYY-MM-DD") + ' ' + this.formatTimeStr(item.vehicleTimeAp),
                            vehicleTime: item.vehicleTime,
                            vehicleTimeAp: item.vehicleTimeAp,
                            cargo: item.cargo,
                            weight: item.weight,
                            remarks: item.remarks,
                            receiveName: item.receiveName,
                            areaFormat: this.formatArea(item.area, item.receiveAddress),
                            area: item.area,
                            receiveAddress: item.receiveAddress,
                            receiveRegionId: item.receiveRegionId,
                            receiveContacts: item.receiveContacts,
                            receiveContactsTel: item.receiveContactsTel,
                            quotedPrice: item.quotedPrice,
                            vehicleNo: item.vehicleNo,
                            vehicleType: item.vehicleType,
                            driverName: item.driverName,
                            driverIdnumber: item.driverIdnumber,
                            planDetail: res.data.planDetail == null ? [] : res.data.planDetail.reverse(),
                        }
                        this.showDetail = true
                        this.showPlanEdit = false
                    } else {
                        Toast(res.msg)
                    }
                })
            },
            addPopRec() {
                this.showEdit = false;
                this.addShowPopRec = true;
                this.addValue = {
                    receiveName: undefined,
                    receiveAddress: undefined,
                    contacts: undefined,
                    contactsTel: undefined,
                    area: undefined,
                };
                this.showPickerArea = false;
            },
            onSearch() {
                this.inList = [];
                this.completeList = [];
                this.completePage = 1;
                this.inPage = 1;
                this.show = true;
                this.addShowPop = false;
                this.onLoad();
            },
            onSearchRec() {
                this.listRec = [];
                this.pageRec = 1;
                this.showRec = true;
                this.addShowPopRec = false;
                this.radioRec = 1;
                this.selCustomerReceiveP();
            },
            reset() {
                if (this.showPlanEdit) {
                    this.newVal.vehicleTime = this.$moment(new Date()).format("YYYY-MM-DD")
                    this.newVal.vehicleTimeAp = undefined;
                    this.newVal.warehouseStoreId = undefined;
                    this.newVal.receiveName = undefined;
                    this.newVal.receiveRegionId = undefined;
                    this.newVal.receiveAddress = undefined;
                    this.newVal.receiveContacts = undefined;
                    this.newVal.receiveContactsTel = undefined;
                    this.newVal.area = undefined;
                    this.newVal.cargo = undefined;
                    this.newVal.weight = undefined;
                    this.newVal.remarks = undefined;
                    this.warehouseStoreName = ''
                    this.radio = '2'
                    this.showPicker()
                } else {
                    this.newVal = {
                        vehicleTime: this.$moment(new Date()).format("YYYY-MM-DD"),
                        vehicleTimeAp: undefined,
                        warehouseStoreId: undefined,
                        receiveName: undefined,
                        receiveRegionId: undefined,
                        receiveAddress: undefined,
                        receiveContacts: undefined,
                        receiveContactsTel: undefined,
                        area: undefined,
                        cargo: undefined,
                        weight: undefined,
                        remarks: undefined,
                    };
                    this.warehouseStoreName = ''
                    this.radio = '2'
                    this.showPicker()
                }
            },
            onLoad() {
                this.seltmsOrderPlanPIn();
                this.seltmsOrderPlanPComplete();
            },
            seltmsOrderPlanPIn() {
                let param = {
                    key2: this.selVal.key,
                    page: this.inPage,
                    limit: this.pageSize,
                    ouid: localStorage.getItem("ouid"),
                    customerId: localStorage.getItem("customerId"),
                    statusList: [10, 20, 30, 40, 50, 60, 70, 80]
                }
                service.seltmsOrderPlanP(param).then(res => {
                    if (res.code == resCode.success) {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.inList.push(res.data[i]);
                            }
                            this.inPage++
                        } else {
                            this.inFinished = true;
                        }
                        // 加载状态结束
                        this.inLoading = false;
                        this.inIsLoading = false;
                    } else {
                        this.inLoading = false;
                        this.inFinished = true;
                        this.inIsLoading = false;
                        Toast(res.msg)
                    }
                })
            },
            seltmsOrderPlanPComplete() {
                let param = {
                    key2: this.selVal.key,
                    page: this.completePage,
                    limit: this.pageSize,
                    ouid: localStorage.getItem("ouid"),
                    customerId: localStorage.getItem("customerId"),
                    statusList: [100]
                }
                service.seltmsOrderPlanP(param).then(res => {
                    if (res.code == resCode.success) {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.completeList.push(res.data[i]);
                            }
                            this.completePage++
                        } else {
                            this.completeFinished = true;
                        }
                        // 加载状态结束
                        this.completeLoading = false;
                        this.completeIsLoading = false;
                    } else {
                        this.completeLoading = false;
                        this.completeFinished = true;
                        this.completeIsLoading = false;
                        Toast(res.msg)
                    }
                })
            },
            chooseRec(item) {
                this.selValue = item
                return item.radio
            },
            onConfirm() {
                if (this.listRec == [] || this.listRec == null) {
                    Toast('请选择收货地址')
                } else {
                    this.newVal.receiveName = this.selValue.receiveName
                    this.newVal.receiveRegionId = this.selValue.receiveRegionId
                    this.newVal.receiveAddress = this.selValue.receiveAddress
                    this.newVal.receiveContacts = this.selValue.contacts
                    this.newVal.receiveContactsTel = this.selValue.contactsTel
                    this.newVal.area = this.selValue.area + ' ' + this.newVal.receiveAddress
                    this.showRec = false
                }
            },
            onEdit(item) {
                this.addShowPopRec = true;
                this.selValue = {
                    customerReceiveId: item.customerReceiveId,
                    receiveName: item.receiveName,
                    receiveRegionId: item.receiveRegionId.toString(),
                    receiveAddress: item.receiveAddress,
                    contacts: item.contacts,
                    contactsTel: item.contactsTel,
                    remarks: item.remarks,
                    area: item.area == null ? item.city + '/' + item.district : item.area,
                }
                this.showPickerArea = false;
                this.showEdit = true;
            },
            resetRec() {
                this.addValue = {
                    receiveName: undefined,
                    receiveAddress: undefined,
                    contacts: undefined,
                    contactsTel: undefined,
                    area: undefined,
                }
            },
            del() {
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定删除吗？',
                    confirmButtonColor: "#6685a4"
                }).then(() => {
                    service.delCustomerReceive({customerReceiveId: this.selValue.customerReceiveId}).then(res => {
                        if (res.code == resCode.success) {
                            Toast(res.data)
                            this.addShowPopRec = false;
                            this.resetRec()
                            this.onSearchRec()
                        } else {
                            Toast(res.msg)
                        }
                    })
                }).catch(() => {

                })
            },
            save() {
                let param = {}
                if (!this.showEdit) {
                    param = this.addValue
                } else {
                    param = this.selValue
                }

                if (isAllEmpty(param.receiveName)) {
                    Toast('请输入收货单位')
                } else if (isAllEmpty(param.receiveRegionId)) {
                    Toast('请输入所在地区')
                } else if (isAllEmpty(param.receiveAddress)) {
                    Toast('请输入详细地址')
                } else if (isAllEmpty(param.contacts)) {
                    Toast('请输入联系人')
                } else if (isAllEmpty(param.contactsTel)) {
                    Toast('请输入手机号码')
                } else if (!isPhone(param.contactsTel)) {
                    Toast('手机号码格式错误，请重新输入')
                } else {
                    param.ouid = localStorage.getItem("ouid")
                    param.customerId = localStorage.getItem("customerId")
                    if (!this.showEdit) {
                        service.addCustomerReceive(param).then(res => {
                            if (res.code == resCode.success) {
                                Toast(res.data)
                                this.addShowPopRec = false;
                                this.resetRec()
                                this.onSearchRec()
                            } else {
                                Toast(res.msg)
                            }
                        })
                    } else {
                        param.customerReceiveId = this.selValue.customerReceiveId
                        service.updCustomerReceive(param).then(res => {
                            if (res.code == resCode.success) {
                                Toast(res.data)
                                this.addShowPopRec = false;
                                this.onSearchRec()
                            } else {
                                Toast(res.msg)
                            }
                        })
                    }
                }
            },
            selAreaStatusValAdd(value) {
                let area = ''
                value.map(it => {
                    area += it.name + '/'
                })
                this.addValue.receiveRegionId = value[2].code
                this.addValue.area = area.substring(0, area.length - 1)
                this.showPickerArea = false;
                this.showSelAreaStatusValAdd = false;
            },
            areaStatusValAddCancel() {
                this.showPickerArea = false
                this.showSelAreaStatusValAdd = false;
            },
            areaStatusValEditCancel() {
                this.showPickerArea = false
                this.showSelAreaStatusValEdit = false;
            },
            selAreaStatusValEdit(value) {
                let area = ''
                value.map(it => {
                    area += it.name + '/'
                })
                this.selValue.receiveRegionId = value[2].code
                this.selValue.area = area.substring(0, area.length - 1)
                this.showPickerArea = false;
                this.showSelAreaStatusValEdit = false;
            },
        }
    }
</script>

<style scoped>
    .van-popup {
        background-color: #f7f8fa;
    }

    .hejcss {
        background-color: #f7f8fa;
        font-size: 15px;
    }

    .searchwarp {
        margin-top: 46px;
    }

    .editwarp {
        width: 100%;
        margin: 56px auto;
    }

    .editwarp .swipewarp {
        margin-bottom: 10px;
    }

    .contentwarp {
        margin-top: 50px;
        height: calc(100vh - 50px) !important;
        /*height: 550px;*/
    }

    .detailHeader {
        background-color: #1989fa;
        height: 70px;
        text-align: center;
        padding-top: 20px;
        margin-bottom: 20px;
        color: white;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .detailLabel {
        color: #727272;
    }

    .detailLabel.detailtitle {
        color: #323233;
        font-weight: bold;
    }

    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow {
        color: #6685a4;
    }

    /deep/ .van-button--info,
    /deep/ .van-button--danger {
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color: #6685a4;
    }

    /deep/ .van-button--warning {
        background-color: #6685a4;
        border: 1px solid #6685a4;
    }

    /deep/ .ewm .van-button--info {
        border: 1px solid #6685a4;
        width: 200px
    }


    .searchwarp[data-v-1405fac1] {
        margin-top: 56px;
    }

    /deep/ .van-calendar__day--start,
    /deep/ .van-calendar__day--end,
    /deep/ .detailHeader[data-v-1405fac1] {
        background-color: #6685a4;
    }

    /deep/ .van-calendar__day--middle {
        background-color: #e4ebf3;
    }

    /*.van-cell::after{
        border-bottom: none;
    }*/
    .van-icon.van-icon-arrow {
        vertical-align: middle;
        margin-left: 5px;
    }

    .van-grid {
        padding: 10px;
    }

    /deep/ .van-image__img {
        border: #e4ebf3 1px solid;
    }

    .closebutton {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        height: 50px;
        width: 100% !important;
        /*font-size: 12px;*/
        z-index: 9999;
    }

    .van-button--default {
        border: 1px solid #e2e2e2;
    }

    .van-divider {
        margin: 0px !important;
    }


    /deep/ .thmx > .van-row {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    /deep/ .van-cell__value.van-cell__value--alone > .thmx:last-child > .van-row {
        padding-top: 10px;
        padding-bottom: 0;
    }

    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 32px;
    }

    .van-address-list__bottom {
        position: fixed;
        bottom: 50px;
        left: 0;
        z-index: 999;
        box-sizing: border-box;
        width: 100%;
        padding: 0;
        background-color: #fff;
    }

    .van-address-detail__bottom {
        position: fixed;
        bottom: 0px;
        left: 0;
        z-index: 999;
        box-sizing: border-box;
        width: 100%;
        padding: 0;
        background-color: #fff;
    }

    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
    }

    .ellipsisRight {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: right;
    }

    .searchwarp {
        margin-top: 46px;
    }

    /deep/ .noon .van-field__control {
        width: 80px;
    }

    .van-doc-demo-block__title {
        margin: 0;
        padding: 15px 16px 10px 16px;
        color: rgba(69, 90, 100, 1);
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
    }

    /deep/ .van-cell__title {
        text-align: left;
        -webkit-box-flex: unset;
        -webkit-flex: unset;
        flex: unset;
        width: 90px;
        color: #969799;
    }

    /deep/ .van-cell__value {
        color: #323233;
    }


    .button {
        font-size: 16px;
        color: #ffffff;
        background: #6685a4;
        height: 40px;
    }

    .van-cell__title {
        -webkit-box-flex: unset;
        -webkit-flex: unset;
        flex: unset;
        width: 90px;
    }

    /deep/ .yqsm .van-cell__value {
        text-align: left;
    }

    /deep/ .van-cell__title {
        text-align: left;
    }

    /deep/ .address .van-cell {
        padding: 10px 16px 10px 20px;
    }
</style>